import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { HeadingComponent } from '../../../heading/heading.component';

import { ContainerComponent } from '../../../container/container.component';
import { TextHtmlParagraphComponent } from '../../../text-html/text-html-paragraph.component';

@Component({
    selector: 'sirius-card-collection-text',
    templateUrl: './card-collection-text.component.html',
    styleUrls: ['./card-collection-text.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [HeadingComponent, ContainerComponent, TextHtmlParagraphComponent],
})
export class CardCollectionTextComponent {
    @Input() eyebrow = '';
    @Input() title = '';
    @Input() text = '';
}
